import styles from './PriceBlock.module.scss';
import replace from 'react-string-replace';

import { IPriceBlock } from './IPriceBlock';
import { ReactNodeArray } from 'react';

export default function PriceBlock({ block }: { block: IPriceBlock }) {
  const variants = block.variants
    .map(variant => {
      let modifiedVariant: ReactNodeArray = replace(variant, /(\$\d+ USD)/g, (match, idx) => {
        return (
          <span className={styles.price} key={idx}>{match}</span>
        );
      });

      modifiedVariant = replace(modifiedVariant, /( - )/g, (_, idx) => {
        return <br key={`variant-linebreak-${idx}`} />;
      });

      return modifiedVariant;
    });

  return (
    <article className={[ styles.block, block.refsheet ? styles.refsheet : '' ].join(' ')}>
      <div className={styles.example}>
        <a href={block.example} target="_blank">
          <img src={block.example} alt={block.name} />
        </a>
      </div>

      <div className={styles.content}>
        <h3>{block.name}</h3>

        <div className={styles.variants}>
          {variants && variants.map((variant, idx) => {
            return (
              <div className={styles.variant} key={idx}>{variant}</div>
            );
          })}
        </div>

        <div dangerouslySetInnerHTML={{ __html: block.body }} />
      </div>
    </article>
  );
}
